<template>
    <div class="table-responsive">
        <table class="table table-success table-striped table-hover mb-0">
            <thead class="thead-primary">
                <tr>
                    <th style="width:100px"></th>
                    <th style="width:100px">
                        <img :src="reportStore.images.transunion" alt="image" width="75" height="75" class="d-block">
                    </th>
                    <th style="width:100px">
                        <img :src="reportStore.images.experian" alt="image" width="75" height="75" class="d-block">
                    </th>
                    <th style="width:100px">
                        <img :src="reportStore.images.equifax" alt="image" width="75" height="75" class="d-block">
                    </th>
                </tr>
            </thead>
            <tbody class="table-striped">
                <tr>
                    <td>Account Number:</td>
                    <td>{{ account[0].account_number }}</td>
                    <td>{{ account[1].account_number }}</td>
                    <td>{{ account[2].account_number }}</td>
                </tr>
                <tr>
                    <td>Account Status:</td>
                    <td>{{ account[0].account_status }}</td>
                    <td>{{ account[1].account_status }}</td>
                    <td>{{ account[2].account_status }}</td>
                </tr>
                <tr>
                    <td>Account Type:</td>
                    <td>{{ account[0].account_type }}</td>
                    <td>{{ account[1].account_type }}</td>
                    <td>{{ account[2].account_type }}</td>
                </tr>
                <tr>
                    <td>Account Detail:</td>
                    <td>{{ account[0].account_detail }}</td>
                    <td>{{ account[1].account_detail }}</td>
                    <td>{{ account[2].account_detail }}</td>
                </tr>
                <tr>
                    <td>Bureau Code:</td>
                    <td>{{ account[0].bureau_code }}</td>
                    <td>{{ account[1].bureau_code }}</td>
                    <td>{{ account[2].bureau_code }}</td>
                </tr>
                <tr>
                    <td>Monthly Payment:</td>
                    <td>{{ account[0].monthly_payment }}</td>
                    <td>{{ account[1].monthly_payment }}</td>
                    <td>{{ account[2].monthly_payment }}</td>
                </tr>
                <tr>
                    <td>Payment Status:</td>
                    <td>{{ account[0].payment_status }}</td>
                    <td>{{ account[1].payment_status }}</td>
                    <td>{{ account[2].payment_status }}</td>
                </tr>
                <tr>
                    <td>Past Due:</td>
                    <td>{{ reportStore.formatDate(account[0].past_due) }}</td>
                    <td>{{ reportStore.formatDate(account[1].past_due) }}</td>
                    <td>{{ reportStore.formatDate(account[2].past_due) }}</td>
                </tr>
                <tr>
                    <td>Date Opened:</td>
                    <td>{{ reportStore.formatDate(account[0].date_opened) }}</td>
                    <td>{{ reportStore.formatDate(account[1].date_opened) }}</td>
                    <td>{{ reportStore.formatDate(account[2].date_opened) }}</td>
                </tr>
                <tr>
                    <td>Date Last Active:</td>
                    <td>{{ reportStore.formatDate(account[0].date_last_active) }}</td>
                    <td>{{ reportStore.formatDate(account[1].date_last_active) }}</td>
                    <td>{{ reportStore.formatDate(account[2].date_last_active) }}</td>
                </tr>
                <tr>
                    <td>Date Last Payment:</td>
                    <td>{{ reportStore.formatDate(account[0].date_last_payment) }}</td>
                    <td>{{ reportStore.formatDate(account[1].date_last_payment) }}</td>
                    <td>{{ reportStore.formatDate(account[2].date_last_payment) }}</td>
                </tr>
                <tr>
                    <td>High Credit:</td>
                    <td>{{ account[0].high_credit }}</td>
                    <td>{{ account[1].high_credit }}</td>
                    <td>{{ account[2].high_credit }}</td>
                </tr>
                <tr>
                    <td>Last Reported:</td>
                    <td>{{ reportStore.formatDate(account[0].last_reported) }}</td>
                    <td>{{ reportStore.formatDate(account[1].last_reported) }}</td>
                    <td>{{ reportStore.formatDate(account[2].last_reported) }}</td>
                </tr>
                <tr>
                    <td>Month Term:</td>
                    <td>{{ account[0].number_of_months }}</td>
                    <td>{{ account[1].number_of_months }}</td>
                    <td>{{ account[2].number_of_months }}</td>
                </tr>
                <tr>
                    <td>Comments:</td>
                    <td>{{ account[0].comments }}</td>
                    <td>{{ account[1].comments }}</td>
                    <td>{{ account[2].comments }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { useReportStore } from '../../stores/ReportStore.js'
    export default {
        mounted() {
        },
        setup() {
            return {
                reportStore: useReportStore()
            }
        },
        props: {
            account: {
                type: [Array, Object]
            }
        },
    }
</script>
